export default __webpack_public_path__ + "static/router_b.9cd820b192da702dadbc07eb4b9d5503.svg";